import {useEffect, useReducer} from "react";

import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {selectedRecommendationsReducer} from "../../utils/multi_lead/selected_recommendations_reducer";

interface IProps {
    recommendedProperties: IRecommendedProperty[];
    recommendedOffers: IRecommendedOffer[];
    recommendationType: ApplicationMultiLeadRecommendationType;
    maxRecommendationsShown?: number;
    selectAllOnRefresh?: boolean;
}

export const useRecommendationsSelection = (props: IProps) => {
    const {recommendedProperties, recommendedOffers, recommendationType, maxRecommendationsShown, selectAllOnRefresh} = props;

    const isMinimumSelection = typeof maxRecommendationsShown === "number" && maxRecommendationsShown === 0;
    const selectedProperties = isMinimumSelection ? [] : recommendedProperties.slice(0, maxRecommendationsShown || recommendedProperties.length);
    const selectedOffers = isMinimumSelection ? [] : recommendedOffers.slice(0, maxRecommendationsShown || recommendedOffers.length);

    const [selectedRecommendations, dispatchSelectedRecommendations] = useReducer(selectedRecommendationsReducer, {
        property: selectedProperties.map((item) => item.id),
        offer: selectedOffers.map((item) => item.id)
    });

    useEffect(() => {
        if (selectAllOnRefresh) {
            selectAll();
        }
    }, [recommendedProperties, recommendedOffers]);

    const selectedRecommendationsCount =
        recommendationType === ApplicationMultiLeadRecommendationType.PROPERTY ? selectedRecommendations.property.length : selectedRecommendations.offer.length;

    const isRecommendationSelected = (recommendationId: number): boolean => {
        switch (recommendationType) {
            case ApplicationMultiLeadRecommendationType.PROPERTY: {
                return selectedRecommendations.property.includes(recommendationId);
            }
            case ApplicationMultiLeadRecommendationType.OFFER: {
                return selectedRecommendations.offer.includes(recommendationId);
            }
            default:
                return false;
        }
    };

    const toggleRecommendation = (recommendationId: number) => {
        const isSelected = isRecommendationSelected(recommendationId);

        switch (recommendationType) {
            case ApplicationMultiLeadRecommendationType.PROPERTY:
                dispatchSelectedRecommendations({type: "property", payload: recommendationId});
                return !isSelected;
            case ApplicationMultiLeadRecommendationType.OFFER:
                dispatchSelectedRecommendations({type: "offer", payload: recommendationId});
                return !isSelected;
            default:
                throw new Error("Unknown recommendation type");
        }
    };

    const selectAll = () => {
        switch (recommendationType) {
            case ApplicationMultiLeadRecommendationType.PROPERTY:
                dispatchSelectedRecommendations({type: "property", payload: recommendedProperties.map((item) => item.id)});
                break;
            case ApplicationMultiLeadRecommendationType.OFFER:
                dispatchSelectedRecommendations({type: "offer", payload: recommendedOffers.map((item) => item.id)});
                break;
            default:
                throw new Error("Unknown recommendation type");
        }
    };

    const resetSelection = () => {
        dispatchSelectedRecommendations({type: "reset"});
    };

    return {
        selectedRecommendations:
            recommendationType === ApplicationMultiLeadRecommendationType.PROPERTY ? selectedRecommendations.property : selectedRecommendations.offer,
        isRecommendationSelected,
        selectedRecommendationsCount,
        toggleRecommendation,
        resetSelection
    };
};
import {useEffect, useReducer} from "react";

import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {selectedRecommendationsReducer} from "../../utils/multi_lead/selected_recommendations_reducer";

interface IProps {
    recommendedProperties: IRecommendedProperty[];
    recommendedOffers: IRecommendedOffer[];
    recommendationType: ApplicationMultiLeadRecommendationType;
    maxRecommendationsShown?: number;
    selectAllOnRefresh?: boolean;
}

export const useRecommendationsSelection = (props: IProps) => {
    const {recommendedProperties, recommendedOffers, recommendationType, maxRecommendationsShown, selectAllOnRefresh} = props;

    const isMinimumSelection = typeof maxRecommendationsShown === "number" && maxRecommendationsShown === 0;
    const selectedProperties = isMinimumSelection ? [] : recommendedProperties.slice(0, maxRecommendationsShown || recommendedProperties.length);
    const selectedOffers = isMinimumSelection ? [] : recommendedOffers.slice(0, maxRecommendationsShown || recommendedOffers.length);

    const [selectedRecommendations, dispatchSelectedRecommendations] = useReducer(selectedRecommendationsReducer, {
        property: selectedProperties.map((item) => item.id),
        offer: selectedOffers.map((item) => item.id)
    });

    useEffect(() => {
        if (selectAllOnRefresh) {
            selectAll();
        }
    }, [recommendedProperties, recommendedOffers]);

    const selectedRecommendationsCount =
        recommendationType === ApplicationMultiLeadRecommendationType.PROPERTY ? selectedRecommendations.property.length : selectedRecommendations.offer.length;

    const isRecommendationSelected = (recommendationId: number): boolean => {
        switch (recommendationType) {
            case ApplicationMultiLeadRecommendationType.PROPERTY: {
                return selectedRecommendations.property.includes(recommendationId);
            }
            case ApplicationMultiLeadRecommendationType.OFFER: {
                return selectedRecommendations.offer.includes(recommendationId);
            }
            default:
                return false;
        }
    };

    const toggleRecommendation = (recommendationId: number) => {
        const isSelected = isRecommendationSelected(recommendationId);

        switch (recommendationType) {
            case ApplicationMultiLeadRecommendationType.PROPERTY:
                dispatchSelectedRecommendations({type: "property", payload: recommendationId});
                return !isSelected;
            case ApplicationMultiLeadRecommendationType.OFFER:
                dispatchSelectedRecommendations({type: "offer", payload: recommendationId});
                return !isSelected;
            default:
                throw new Error("Unknown recommendation type");
        }
    };

    const selectAll = () => {
        switch (recommendationType) {
            case ApplicationMultiLeadRecommendationType.PROPERTY:
                dispatchSelectedRecommendations({type: "property", payload: recommendedProperties.map((item) => item.id)});
                break;
            case ApplicationMultiLeadRecommendationType.OFFER:
                dispatchSelectedRecommendations({type: "offer", payload: recommendedOffers.map((item) => item.id)});
                break;
            default:
                throw new Error("Unknown recommendation type");
        }
    };

    const resetSelection = () => {
        dispatchSelectedRecommendations({type: "reset"});
    };

    return {
        selectedRecommendations:
            recommendationType === ApplicationMultiLeadRecommendationType.PROPERTY ? selectedRecommendations.property : selectedRecommendations.offer,
        isRecommendationSelected,
        selectedRecommendationsCount,
        toggleRecommendation,
        resetSelection
    };
};
